/*
 * @Author: jiakaiwen jiakaiwen@huihaiyinhe.com
 * @Date: 2026-03-20 11:19:54
 * @LastEditors: jiakaiwen jiakaiwen@huihaiyinhe.com
 * @LastEditTime: 2026-03-20 17:43:46
 * @FilePath: /work.xhey.top/src/app/hooks/useWebSearchFilterHistory.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { useMemo } from 'react'
import { useLocalStorageState } from 'ahooks'
import { useAppSelector } from '../hooks'

export type WebSearchFilterHistoryItem = {
  id: string
  text: string
  createdAt?: number
  /**
   * 由服务端/前端根据筛选条件拼装的展示文案写入的历史（非用户纯手输关键词历史）
   */
  isSessionGenerated?: boolean
}

type UseWebSearchHistoryParams = {
  storageKeySuffix: string
  maxHistoryLength: number
}

const useWebSearchHistory = ({
  storageKeySuffix,
  maxHistoryLength
}: UseWebSearchHistoryParams) => {
  const groupID = useAppSelector((state) => state.group.groupId)

  const storageKey = `${groupID}${storageKeySuffix}`
  const [history, setHistory] = useLocalStorageState<
    WebSearchFilterHistoryItem[]
  >(storageKey, {
    defaultValue: [],
    listenStorageChange: true
  })

  const normalizedHistory: WebSearchFilterHistoryItem[] = useMemo(() => {
    return Array.isArray(history)
      ? history.map((item) => ({
          ...item,
          createdAt: Number(item?.createdAt) || 0,
          // 旧数据无字段时视为生成类历史（该存储仅用于拼装文案）
          isSessionGenerated:
            item?.isSessionGenerated === undefined
              ? true
              : item.isSessionGenerated
        }))
      : []
  }, [history])

  const addHistory = (item: WebSearchFilterHistoryItem) => {
    if (!item?.id || !item?.text) return

    setHistory((prevHistory = []) => {
      const now = Date.now()
      const filtered = prevHistory.filter((h) => h?.id !== item.id)
      // 正常插入：追加到末尾，超出时保留最新 maxHistoryLength 条
      const next = [...filtered, { ...item, createdAt: now }]
      return next.slice(Math.max(0, next.length - maxHistoryLength))
    })
  }

  const clearHistory = () => {
    setHistory([])
  }

  return {
    history: normalizedHistory,
    addHistory,
    clearHistory
  }
}

export const useWebSearchFilterHistory = () => {
  return useWebSearchHistory({
    storageKeySuffix: '_web_search_filter_history',
    maxHistoryLength: 10
  })
}

export const useWebSearchKeywordFilterHistory = () => {
  return useWebSearchHistory({
    storageKeySuffix: '_web_search_keyword_filter_history',
    maxHistoryLength: 6
  })
}
